import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SimulatorModel } from '../models/SimulatorModel';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { GeneralDataModel } from '../models/GeneralDataModel';
import { SuesModel } from '../models/SuesModel';
import { useSelector } from 'react-redux';
import { RootState } from '../app-context/store';


type Props = {
    filter: any;
    policyTypes: any[];
    productionTypes: any[];
    onApprove: Function;
    onClear: Function;
    onHide: Function;
};

const AdvancedClientSuesFilter = (props: Props) => {
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const suesModel = new SuesModel();

    const filterCleaned = useSelector((state: RootState) => state.sues.filterCleaned);

    const [filter, setFilter] = useState<any>(props.filter ? props.filter : {});

    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');
    const [selectedThirdPartyInsuranceCompany, setThirdPartySelectedInsuranceCompany] = useState<string>('');

    const [vehiclePolicyTypes, setVehiclePolicyTypes] = useState<any[]>([]);
    const [vehiclePolicyType, setVehiclePolicyType] = useState<string>('-1');

    const [sueStatusesList, setSueStatusesLists] = useState<any[]>([]);
    const [sueStatus, setSueStatus] = useState<string>('-1');

    const [sueTypesList, setSueTypesLists] = useState<any[]>([]);
    const [sueType, setSueType] = useState<string>('-1');


    const init = async () => {

        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [{
            value: '-1',
            label: 'פלוס שירותי דרך'
        }];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        setInsuranceCompanyList(fixedInsuranceCompanies);

        const InsuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const insuranceTypesKeys = Object.keys(InsuranceTypesData);
        const insuranceTypesList: any[] = [];
        insuranceTypesKeys.forEach((key: string) => {
            const item = InsuranceTypesData[key];
            insuranceTypesList.push(
                {
                    label: item.description,
                    value: item.id.toString()
                })

        });
        setVehiclePolicyTypes(insuranceTypesList);

        try {
            const sueStatusesData = await suesModel.sueStatusGetAll();
            sueStatusesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
            setSueStatusesLists(sueStatusesData.map((st: any) => {
                return {
                    label: st.name,
                    value: st.id.toString()
                }
            }));
        } catch (error) {
            setSueStatusesLists([]);
        }

        try {
            const sueTypesData = await suesModel.sueTypeGetAll();
            sueTypesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
            setSueTypesLists(sueTypesData.map((st: any) => {
                return {
                    label: st.name,
                    value: st.id.toString()
                }
            }));
            // setSueTypesLists(sueTypesList);
        } catch (error) {
            setSueTypesLists([]);
        }

    }


    const onInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setSelectedInsuranceCompany(companyName);
        const selected = insuranceCompanyList.find((a: any) => a.label == companyName);
        const newFilter = filter;
        if (selected) {
            newFilter.insuranceCompanyId = selected.value
            setSelectedInsuranceCompany(selected.label)
            setFilter(newFilter);
        } else {
            newFilter.insuranceCompanyId = undefined
            setFilter(newFilter);
        }
    }

    const onThirdPartyInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setThirdPartySelectedInsuranceCompany(companyName);
        const selected = insuranceCompanyList.find((a: any) => a.label == companyName);
        const newFilter = filter;
        if (selected) {
            newFilter.thirdPartyInsuranceCompanyId = selected.value
            setThirdPartySelectedInsuranceCompany(selected.label)
            setFilter(newFilter);
        } else {
            newFilter.thirdPartyInsuranceCompanyId = undefined
            setFilter(newFilter);
        }
    }


    const onClearInsuranceCompany = () => {
        const newFilter: any = filter;
        newFilter.insuranceCompanyId = undefined;
        setSelectedInsuranceCompany('');
        setFilter(newFilter);
    }
    const onClearThirdPartyInsuranceCompany = () => {
        const newFilter: any = filter;
        newFilter.insuranceCompanyId = undefined;
        setThirdPartySelectedInsuranceCompany('');
        setFilter(newFilter);
    }


    const onVehiclePolicyTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onVehiclePolicyTypeChange');
        setVehiclePolicyType('-1');
        const newFilter = filter;
        newFilter.vehiclePolicyTypeLabel = undefined;
        if (value !== '-1') {
            newFilter.vehiclePolicyType = parseInt(value);
            if (option) {
                newFilter.vehiclePolicyTypeLabel = (option as any).label;
            }
            setVehiclePolicyType(value.toString());
        } else {
            newFilter.vehiclePolicyType = undefined;
        }
        setFilter(newFilter);
    }


    const onSueStatusChange = (value: string, option: { label: string; value: string; }) => {
        setSueStatus(value);
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.sueStatusId = value
        } else {
            newFilter.sueStatusId = undefined;
        }
        setFilter(newFilter);
    }

    const onSueTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        setSueType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.sueTypeId = value;
            setSueType(value);
        } else {
            newFilter.sueTypeId = undefined;
        }
        setFilter(newFilter);
    }


    const onApprove = () => {
        if (props.onApprove) {
            const newFilter = filter;
            props.onApprove(newFilter);
        }
    }
    const onClear = () => {
        setFilter({});
        setSueStatus('-1');
        setSueType('-1');

        setVehiclePolicyType('-1');
        setSelectedInsuranceCompany('');
        setThirdPartySelectedInsuranceCompany('');
        if (props.onClear) {
            props.onClear()
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        if (filterCleaned) {
            onClear();
        }
    }, [filterCleaned])

    useEffect(() => {
        console.log('props', props)
        if (props.filter) {
            setFilter(props.filter)
        }
    }, [props])


    return (
        <div className='sues-advanced-search rtl'>
            <div className="close-icon pointer" onClick={onClose}></div>
            <div className="parameter-row">

                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג ביטוח
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג ביטוח"
                                value={vehiclePolicyType}
                                options={[
                                    {
                                        label: 'בחר סוג ביטוח',
                                        value: '-1'
                                    },
                                    ...vehiclePolicyTypes
                                ]}
                                onChange={onVehiclePolicyTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>

                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סטטוס תביעה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סטטוס תביעה"
                                value={sueStatus}
                                options={[
                                    {
                                        label: 'בחר סטטוס תביעה',
                                        value: '-1'
                                    },
                                    ...sueStatusesList
                                ]}
                                onChange={(value: string, option: any) => onSueStatusChange(value, option)}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג תביעה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג תביעה"
                                value={sueType}
                                options={[
                                    {
                                        label: 'בחר סוג תביעה',
                                        value: '-1'
                                    },
                                    ...sueTypesList
                                ]}
                                onChange={onSueTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>

            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            חברה מבטחת
                        </div>
                        <div className="value">
                            <input type='text'
                                list="companies_list"
                                placeholder='בחר חברת מבטחת'
                                onChange={(e: any) => onInsuranceCompanyChange(e)}
                                value={selectedInsuranceCompany}
                            />
                            <datalist id="companies_list">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>

                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            חברת צ"ג
                        </div>
                        <div className="value">
                            <input type='text'
                                list="companies_list2"
                                placeholder='בחר חברת צ"ג'
                                onChange={onThirdPartyInsuranceCompanyChange}
                                value={selectedThirdPartyInsuranceCompany}
                            />
                            <datalist id="companies_list2">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedThirdPartyInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearThirdPartyInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>


            <button className="act-btn pointer" onClick={onApprove}>הצג דוח</button>
            <button className="act-btn pointer" onClick={onClear}>נקה בחירה</button>

        </div>
    )
}

export default AdvancedClientSuesFilter;